export interface SchoolSettings {
  id: string;
  schoolName: string;
  logoUrl: string | null;
  gradientStartColor: string;
  gradientEndColor: string;
  /** Sales-tax rate as a decimal (e.g. 0.07 for 7%). Applied only
   *  to fees flagged `taxable: true` — typically concession-stand
   *  items, merch, and event tickets, while educational fees stay
   *  tax-exempt. */
  taxRate: number;
  updatedAt: string;
  updatedBy: string | null;
}

export const defaultSchoolSettings: SchoolSettings = {
  id: '1',
  schoolName: 'ClearCollect School',
  logoUrl: null,
  gradientStartColor: '#0d9488',
  gradientEndColor: '#0891b2',
  taxRate: 0.07,
  updatedAt: new Date().toISOString(),
  updatedBy: null,
};

let currentSettings: SchoolSettings = { ...defaultSchoolSettings };

export const getSchoolSettings = (): SchoolSettings => {
  return { ...currentSettings };
};

export const updateSchoolSettings = (updates: Partial<Omit<SchoolSettings, 'id'>>): SchoolSettings => {
  currentSettings = {
    ...currentSettings,
    ...updates,
    updatedAt: new Date().toISOString(),
  };
  return { ...currentSettings };
};
